import { gql } from '@apollo/client';

export const CREATE_ARBEITSBEREICH_STATION = gql(`
  mutation rotationsplan_createArbeitsbereichStation($input: mitarbeiter_createArbeitsbereichStationInput!) {
   mitarbeiter_createArbeitsbereichStation(input: $input){
    error {
      message
    }
    success {
      station {
        ... on mitarbeiter_rotationsplanArbeitsbereichStation {
          von
          bis
          id
          abteilungsleiter {
            id
            nachname
            vorname
          }
          arbeitsbereich {
            id
            name
            markierung
          }
        }
      }
      fristResult {
        error {
          message
        }
        success {
          id
        }
      }
    }
   }
  }
`);
